import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";

import { StorePickerModal } from "@/components/Store/StorePicker/storePickerModal.container";
import { StorePickerFeature } from "@/components/Store/StorePicker/types/storePickerFeature.enum";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { APIStatus } from "@/redux/modules/api/data/cart/cart.module";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { GetStoreStrategy } from "@/services/store.service";
import { StorePickerModalStates } from "@/utils/enums";
import { useStore } from "@/utils/hooks/store/useStore.hook";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

import { useActionHandlerContext } from "../../context/actionHandler.context";
import { useECommerceContext } from "../../context/eCommerce.context";
import { useStorePickerModalContext } from "../../context/storePickerModal.context";
import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";
import { useProductDetail } from "../../hooks/useProductDetail.hook";

const StorePickerSelectComponent = () => {
    const { t } = useGranite();
    const { storePickerType, storePickerModalState, setStorePickerModalState } =
        useStorePickerModalContext();
    const { isEcommerceReady, infoLink } = useECommerceContext();
    const { isBoxArticle, sku } = useECommerceProduct();
    const { deliveryType } = useProductDetail();
    const { open: openModal } = useModalRouter(ModalType.AddToCart);
    const { onAddToCart } = useActionHandlerContext();

    const { store } = useStore({
        strategy: GetStoreStrategy.Session,
        sku: sku
    });

    return (
        <>
            {isEcommerceReady && storePickerType === StorePickerType.SELECT && (
                <StorePickerModal
                    isOpen={
                        storePickerModalState !== StorePickerModalStates.Closed
                    }
                    type={StorePickerType.SELECT}
                    displayStockLevel={!isBoxArticle}
                    infoLink={infoLink}
                    storeCode={store?.code ?? null}
                    fixedFeatures={
                        deliveryType === DeliveryType.ClickAndCollect
                            ? [StorePickerFeature.BUY_ONLINE_PICKUP_IN_STORE]
                            : []
                    }
                    onClose={() =>
                        setStorePickerModalState(StorePickerModalStates.Closed)
                    }
                    submitButtonText={
                        storePickerModalState ===
                        StorePickerModalStates.AddToCart
                            ? t(
                                  "general.storepicker.button.confirmStoreAndOrder"
                              )
                            : ""
                    }
                    onSubmit={(shop, onClose) => {
                        if (
                            storePickerModalState !==
                            StorePickerModalStates.AddToCart
                        ) {
                            onClose?.();
                            return;
                        }

                        onAddToCart(shop.code).then((action) => {
                            if (action.type === APIStatus.SUCCESS) {
                                onClose?.();
                                openModal();
                            } else if (action.type === APIStatus.FAILURE) {
                                broadcastMessage({
                                    id: "pdp-error",
                                    text: action.payload.message,
                                    status: "danger",
                                    dismissible: true
                                });
                            }
                        });
                    }}
                />
            )}
        </>
    );
};

export { StorePickerSelectComponent };
